<template>
  <div class="question-wrap" v-if="currentQuestion">
    <div class="box-question">
      <div class="exercise-content">
        <div class="tips">提示：答对即可解锁下一节视频。</div>
        <div class="question">
          <div class="stem">
            <span v-if="+currentQuestion.questionType === 0">[单项选择题]</span>
            <span v-if="+currentQuestion.questionType === 1">[多项选择题]</span>
            <span v-if="+currentQuestion.questionType === 2">[判断题]</span>
            <span v-if="+currentQuestion.questionType === 3">[解答题]</span>
            {{ currentQuestion.subjectName }}
          </div>
          <!-- 0-选择题(单选) 1-选择题(多选) 2-判断题(0-false 1-true) 3-解答题 -->
          <div v-if="singleArr.includes(+currentQuestion.questionType)">
            <div
              @click="handleSetmOption(index, item.optionName)"
              class="stem-option"
              :class="{ 'setm-option-active': index === setmActive }"
              v-for="(item, index) in currentQuestion.optionDtoList"
              :key="index"
            >
              <i></i>{{ item.optionName }}、{{ item.optionValue }}
            </div>
          </div>
          <!-- 多选 -->
          <div v-if="+currentQuestion.questionType === 1">
            <a-checkbox-group @change="handleCheckbox">
              <a-checkbox
                v-for="(item, index) in currentQuestion.optionDtoList"
                :key="item.optionName"
                :value="item.optionName + '::' + index"
              >
                {{ item.optionName }}、{{ item.optionValue }}
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
        <div class="exercise-send-wrapper">
          <div class="exercise-send" @click="submitFunc">
            {{ isFalse ? "重试" : "提交" }}
          </div>
        </div>
      </div>
      <div class="answer-info" v-show="isFalse">
        [解析]：{{ currentQuestion.analysis }}
      </div>
    </div>
  </div>
</template>

<script>
import { artQuestionBankAnswer } from "@/api/CourseCenter";
export default {
  name: "Question",
  data() {
    return {
      setmActive: null,
      type: "",
      questionList: [], // 题目列表
      questionIndex: 0,
      chapterId: "",
      singleArr: [0, 2], // 标识为单项选择的
      currentQuestion: {}, // 当前题目信息
      checkedValue: [], // 多选题 选中的选项
      exactness: [], // 正确选项，
      singleAnswer: "", // 单选和判断题的当前答案
      videoOpinion: "", // 心得
      isFalse: false, // 是否答对
    };
  },
  props: {
    videoQuestionList: Array,
  },
  watch: {
    videoQuestionList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.questionList = newVal;
        this.currentQuestion = newVal[0];
        console.log("视频", this.questionList);
      },
      immediate: true,
    },
  },
  mounted() {
    this.type = this.$route.query.type;
    this.chapterId = this.$route.query.chapterId;
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleCheckbox(checkdValue) {
      console.log("checkdValue", checkdValue);
      this.checkedValue = checkdValue;
    },
    handleSetmOption(index, answer) {
      this.setmActive = index;
      this.singleAnswer = answer;
    },
    submitFunc() {
      console.log("submitFunc", this.currentQuestion);
      let current = this.currentQuestion;
      let checkedValue = this.checkedValue;
      if (this.singleArr.includes(+this.currentQuestion.questionType)) {
        if (!this.singleAnswer) {
          this.$message.error("请作答！");
          return;
        }
        if (this.singleAnswer === current.answer) {
          this.updateTopic(current);
          this.isFalse = false;
        } else {
          // this.updateTopic();
          this.isFalse = true;
        }
      }
      if (+current.questionType === 1) {
        if (!checkedValue.length) {
          this.$message.error("请作答！");
          return;
        }
        let answerList = checkedValue
          .map((item) => {
            let arr = item.split("::");
            return {
              answer: arr[0],
              id: arr[1],
            };
          })
          .sort((a, b) => {
            return a.id - b.id;
          });
        console.log("arr", answerList);

        let answerStr = "";
        answerList.forEach((item) => {
          answerStr += item.answer;
        });

        if (answerStr === current.answer) {
          this.updateTopic(current);
          this.isFalse = false;
        } else {
          // this.updateTopic();
          this.isFalse = true;
        }
      }
    },
    updateTopic(current = null) {
      // status 1: 正确   2：错误
      current && this.exactness.push(current);
      if (this.questionIndex === this.questionList.length - 1) {
        this.artQuestionBankExaminationFunc();
      } else {
        this.questionIndex += 1;
        this.currentQuestion = this.questionList[this.questionIndex];
        this.checkedValue = [];
        this.singleAnswer = "";
        this.setmActive = null;
      }
    },
    artQuestionBankExaminationFunc() {
      let score = this.exactness.reduce((acc, cur) => {
        console.log(acc, cur);
        return acc + parseInt(cur.score);
      }, 0);
      let itemVoList = this.exactness.map((item) => {
        return {
          questionId: item.id,
          submitAnswer: item.answer,
        };
      });
      console.log("scores", score);
      let paramas = {
        chapterId: this.chapterId,
        score,
        type: this.type,
        videoOpinion: this.videoOpinion,
        itemVoList,
      };
      artQuestionBankAnswer(paramas)
        .then((res) => {
          console.log("artQuestionBankAnswer", res);
          this.$message.success("完成测试！");
          this.$emit("changeQuestionStatus");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.question-wrap {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}
.box-question {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  // height: 431px;
  border-radius: 8px;
  border-top: 1px solid #f2f2f2;
  padding: 19px 0 24px;
  background-color: #fff;
  .exercise-content {
    padding: 0 36px 0 23px;
    .tips {
      line-height: 12px;
      font-size: 12px;
      font-size: 12px;
      color: #da514e;
      margin-bottom: 20px;
    }
    .question {
      margin-bottom: 70px;
      .stem {
        line-height: 36px;
        font-size: 17px;
        color: #333;
        margin-bottom: 24px;
        span {
          color: #3fbce9;
        }
      }
      .stem-option {
        margin-bottom: 27px;
        line-height: 15px;
        font-size: 15px;
        color: #333;
        i {
          display: inline-block;
          width: 9px;
          height: 9px;
          border: 1px solid #aaa;
          border-radius: 50%;
          margin: 0 10px 0 36px;
        }
      }
      .setm-option-active {
        color: #7a2489;
        i {
          display: inline-block;
          width: 9px;
          height: 9px;
          border: 1px solid #7a2489;
          border-radius: 50%;
          background: #7a2489;
          box-shadow: 0 0 4px #7a2489;
        }
      }
    }
    .exercise-send-wrapper {
      text-align: center;
    }
    .exercise-send {
      display: inline-block;
      padding: 0 28px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      background-color: #7a2489;
      color: #fff;
      font-size: 15px;
      text-align: center;
      margin-bottom: 26px;
      cursor: pointer;
    }
  }
  .answer-info {
    border-top: 1px solid #f2f2f2;
    padding: 25px 36px 0 23px;
    font-size: 15px;
    color: #3fbce9;
  }
}
</style>
